import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { InputText } from 'primereact/inputtext';

const InputTextPM = ({ value = undefined, placeholder = null, onChange = null, maxLength = -1, className = '' }) => {
  InputTextPM.prototype = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    maxLength: PropTypes.number,
    className: PropTypes.string,
  };

  const onChangeText = event => {
    let {
      target: { value },
    } = event;
    if (maxLength >= 0 && value.length > maxLength) {
      value = value.substring(0, maxLength);
    }

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Fragment>
      <InputText value={value || ''} placeholder={placeholder} className={`InputText ${className}`} onChange={onChangeText} />
    </Fragment>
  );
};

export default InputTextPM;